(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-countdown-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-discount-timer')) {
    class TDDiscountTimer extends HTMLElement {
      constructor() {
        super();
        const countdownDateValue = this.dataset.countdownDate;
        if (countdownDateValue) {
          this.endDate = new Date(countdownDateValue).getTime();
        } else {
          this.endDate = NaN;
        }
        this.interval = null;
        this.countdownFormat = this.dataset.countdownFormat || 'days,hours,minutes,seconds';
        this.formatArray = this.countdownFormat.split(',').map(item => item.trim());
      }
      connectedCallback() {
        this.setupEventListeners();
        setTimeout(() => {
          this.countdownElement = this.querySelector('.td-countdown-timer__countdown');
          this.segmentElements = this.querySelectorAll('.td-countdown-timer__segment');
          
          // Map segments by their data attribute for easy lookup
          this.segmentMap = {};
          this.segmentElements.forEach(segment => {
            const segmentType = segment.dataset.segment;
            if (segmentType) {
              this.segmentMap[segmentType] = segment.querySelector('.td-countdown-timer__value');
            }
          });
          
          if (!isNaN(this.endDate) && this.endDate > 0) {
            const timerFunction = () => {
              const currentDate = new Date().getTime();
              const difference = this.endDate - currentDate;
              if (difference <= 0) {
                clearInterval(timerUpdater);
                this.interval = null;
                this.remove();
                return;
              }
              if (this.countdownElement) {
                this.countdownElement.style.display = null;
              }

              // Calculate all time units
              const days = Math.floor(difference / (1000 * 60 * 60 * 24));
              const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((difference % (1000 * 60)) / 1000);

              const numberFormatter = (number) => {
                if (number < 0) {
                  return '00';
                } else if (number < 10) {
                  return '0' + number;
                }
                return number;
              };
              
              // Update only the segments that are visible based on format
              if (this.segmentMap.days) {
                this.segmentMap.days.innerText = numberFormatter(days);
              }
              if (this.segmentMap.hours) {
                this.segmentMap.hours.innerText = numberFormatter(hours);
              }
              if (this.segmentMap.minutes) {
                this.segmentMap.minutes.innerText = numberFormatter(minutes);
              }
              if (this.segmentMap.seconds) {
                this.segmentMap.seconds.innerText = numberFormatter(seconds);
              }
            };
            const timerUpdater = setInterval(timerFunction, 1000);
            this.interval = timerUpdater;
            timerFunction(); // Run immediately to avoid delay
          } else {
            // If no valid date is set, show placeholder values instead of removing
            if (this.segmentMap.days) {
              this.segmentMap.days.innerText = '--';
            }
            if (this.segmentMap.hours) {
              this.segmentMap.hours.innerText = '--';
            }
            if (this.segmentMap.minutes) {
              this.segmentMap.minutes.innerText = '--';
            }
            if (this.segmentMap.seconds) {
              this.segmentMap.seconds.innerText = '--';
            }
          }
        }, 0);
      }
      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
      setupEventListeners() {
        // Placeholder for any future event listeners
      }
    }
    customElements.define('td-discount-timer', TDDiscountTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
